import React, { useState, useEffect } from "react";

import styles from "./tab-screen-three.module.scss";

export default function TabScreenThree(props) {
  const [state, setState] = useState({});

  useEffect(() => {}, []);

  return (
    <main className={styles.tab_screen_three_container}>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repellendus
      ratione ducimus nam id doloribus quasi minima facilis, quo, delectus
      dolores iure. Iste repellendus possimus aperiam quam aliquid facilis non
      perferendis! Nostrum consequuntur fugiat aut nulla eaque illum dicta
      officia fuga possimus deleniti nobis sed ad cumque delectus architecto
      asperiores quisquam iusto, dolore iure commodi reiciendis nihil mollitia
      maxime similique! Iure! Sunt laborum repellat enim? Nihil, perferendis
      odit. Nemo aspernatur quae numquam porro perferendis culpa ducimus,
      repellendus rerum ratione magnam quo neque inventore repellat fugiat
      tempore consequatur perspiciatis incidunt sed hic? Recusandae, explicabo?
      Fugiat asperiores officia minima earum sint, at, facere dicta dolorum
    </main>
  );
}
